import { Currencies } from "@grandvisionhq/state";
const getPrice = (prices) => {
  if (!Array.isArray(prices) || !prices.length || !prices[0]) {
    return void 0;
  }
  const price = prices[0];
  if (!price.discounted) {
    return {
      originalPrice: price.value.centAmount,
      currency: Currencies[price.value.currencyCode]
    };
  }
  const discounted = price.discounted;
  return {
    currency: Currencies[price.value.currencyCode],
    originalPrice: price.value.centAmount,
    discountedPrice: discounted.value.centAmount
  };
};
export {
  getPrice
};
//# sourceMappingURL=legacy-get-price.js.map
